import React from 'react';
import styled from 'styled-components';
import { IconMusicLibrary } from '@bynder/icons';
import { Translate, useTranslate } from '@bynder/localization';
import {
  StyledAudioHeader,
  StyledAudioName,
  StyledAudioWidget,
} from '../shared/styled-components/Widgets';
import { EmptyWidget } from './EmptyWidget';
import { useGuideStore } from '../../stores/guideStore';

interface Props {
  readOnly: boolean;
  assetId: string;
  audioUrl: string;
  assetName: string;
  handleAddAudioAsset: (
    databaseId: string,
    name: string,
    url: string,
    audioUrl: string,
  ) => void;
}

const AudioWidget: React.FC<Props> = ({
  readOnly,
  assetId,
  audioUrl,
  assetName,
}: Props) => {
  const { translate } = useTranslate();
  const isEmpty = !assetId;
  const audioElement = React.useRef<HTMLAudioElement>();
  const isEditMode = useGuideStore(s => s.isEditMode);

  if (readOnly && isEmpty) {
    return null;
  }

  const audioContainer = !isEmpty ? (
    <>
      <StyledAudioHeader>
        <StyledAudioName>{assetName}</StyledAudioName>
      </StyledAudioHeader>
      <audio ref={audioElement} controls>
        <source src={audioUrl} />
        <Translate id="AUDIO_WIDGET.ERROR_MESSAGE" />
      </audio>
    </>
  ) : null;

  if (isEmpty && isEditMode) {
    return (
      <EmptyWidget
        icon={<IconMusicLibrary />}
        text={translate('WIDGETS_CONSTANTS.EMPTY_AUDIO_WIDGET')}
      />
    );
  }

  return (
    <StyledAudioWidget readOnly={readOnly} $isEmpty={isEmpty}>
      {readOnly ? (
        audioContainer
      ) : (
        <StyledContainer>{audioContainer}</StyledContainer>
      )}
    </StyledAudioWidget>
  );
};

export default AudioWidget;

const StyledContainer = styled.div`
  cursor: pointer;
`;
